import { SupportedCurrency } from '@utils/types/organization/organization';

export function formatCurrency(
  value: number,
  currency: SupportedCurrency = 'EUR'
): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2
  }).format(value);
}
